// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.compelling {\n    background-color: #4ebf59;\n}\n.extreme {\n    background-color: #5ecc69;\n}\n.very-strong {\n    background-color: #71d97b;\n}\n.strong {\n    background-color: #7ee087;\n}\n.moderate {\n    background-color: #91eb9a;\n}\n.anecdotal {\n    background-color: #a1f0a9;\n}\n.no-evidence {\n    background-color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
